import { z } from 'zod';

export const cardSchema = z.object({
  cardNumber: z.string(),
  expirationDate: z.string(),
  cvv: z.string(),
});
